import { Box, Image, Text } from '@chakra-ui/react'
import { ProductModel } from 'domain/goods/model'
import React from 'react'
import { MoneyText } from 'views/component/MoneyText'

type ProductItemProps = {
  product: ProductModel
}

export const ProductItem = ({ product }: ProductItemProps) => {
  return (
    <Box width={'163px'}>
      <Image
        src={product.thumbnail?.path}
        width={'163px'}
        height={'163px'}
        borderRadius={8}
      />
      <Box p={2}>
        <Text fontWeight={'bold'} fontSize={16}>
          {product.name}
        </Text>
        <MoneyText
          amount={product.price}
          unit={'₩'}
          textProps={{ fontWeight: 'bold', fontSize: 16 }}
        />
        <Text mb={1} fontSize={16} color={'gray'}>
          {product.unit_size}
        </Text>
      </Box>
    </Box>
  )
}
